import useStyles from './styles';
import Text from '../Text/Text';
import { TopSpaced, HorizontalSpaced } from '../Spaced/Spaced';
import AppLoading from '../../features/App/AppLoading';

function Panel({ children, title, loadingComponent }: PanelProps) {
  const classes = useStyles();

  const body = (
    <>
      {title && (
        <TopSpaced>
          <HorizontalSpaced>
            <Text>{title}</Text>
          </HorizontalSpaced>
        </TopSpaced>
      )}
      {title ? <TopSpaced size="x-small">{children}</TopSpaced> : children}
    </>
  );

  return (
    <div className={classes.panel}>
      {loadingComponent && <AppLoading loadingComponent={loadingComponent}>{body}</AppLoading>}
      {!loadingComponent && body}
    </div>
  );
}

export default Panel;
